module.exports = __webpack_public_path__ + "img/qrcode.e94f4451.png";